import React, { Component } from 'react'
import * as XLSX from 'xlsx';

import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyRadioGroup from '../BsyRadioGroup';
import BsyIconBtn from "../BsyIconBtn";
import BsySwitchBtn from "../BsySwitchBtn";
import BsyAlert from "../BsyAlert";
import BsyAlertQrcode from "../BsyAlertQrcode";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import imgCodeAlert from "../BsyAlertImgCode/Staticize";
import { BsyUtils } from '../../utils/Utils';
import BsyDialog from '../BsyDialog';
import BsyApprovePane from '../BsyApprovePane';
import BsyAlertMenu from "../BsyAlertMenu";
import './index.css'

class AlertList extends Component {

    static defaultProps = {
        isOther: false,
        dock_corpid: "",
        dock_corp: [],
    }

    constructor(props) {
        super(props);
        this.state = {
            singleInvite: true,
            batchInvite: false,
            formRef: false,
            nicknameError: false,
            dockCorpIdError: false,
            userUniqueIdError: false,
            phoneError: false,
            emailError: false,
            deparsError: false,
            showLink: false,
            linkAddress: "",
            nickname: "",
            phone: "",
            email: "",
            userUniqueId: "",
            remark: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            nocheck: false,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: [],
            dock_corp: props.dock_corp,
            departmentId: props.departmentId ? props.departmentId : [],
            urlDepartmentId: props.urlDepartmentId ? props.urlDepartmentId : [],
            errInfo: [],
            role: [],
            otherLabelId: [],
            cacheKey: "",
            emailCodeLogin: true,
            mobileCodeLogin: true,
            approve_switch: false,
            isAllDept: props.isAllDept,
            isOther: props.isOther,
            isAddRoleLabel: props.isAddRoleLabel,
            dock_corpid: props.dock_corpid,
            filterText: "",
            import_mode: 'merge'// 默认 "replace"  //贾维斯本地版 'merge'

        }
        this.copyCont = React.createRef();
        this.dialogEl = React.createRef();
    }
    componentDidMount() {
        this.inviteOpenurlGet();
    
    }
 
    inviteOpenurlGet = () => {
        let depars;
        let deparst;
        const {isOther} = this.state;
        if (this.state.isAllDept) {
            depars = this.state.urlDepartmentId.map((item, index) => {
                return item._id
            })
            depars = depars[0];
            deparst = this.state.urlDepartmentId;
        } else {
            depars = this.props.deptId;
            deparst = this.state.departmentId;
        }
        if(isOther){
            React.axios('/corp/dock/member/join_link', {
                corpId: window.FX.STATIC.corpId,
                dock_corpid: this.state.dock_corpid,
            }).then(res => {
                this.setState({
                    linkAddress: res.data.openurl,
                    showLink: res.data.openurl_switch,
                    nocheck: res.data.nocheck,
                    approve_switch: res.data.isCheck,
                    // import_mode: res.data.import_style, ???? 为什么系统管理员默认是替换
                    emailCodeLogin: res.data.emailCodeLogin,
                    mobileCodeLogin: res.data.mobileCodeLogin,
                    mergeDept: res.data.mergeDept,
                    urlDepartmentId: deparst,
                })
            }).catch(res => {
    
            })
        }else{
            React.axios('/corp/member/invite_openurl_get', {
                corpId: window.FX.STATIC.corpId,
                dock_corpid: this.state.dock_corpid,
                _id: depars,
            }).then(res => {
                this.setState({
                    linkAddress: res.data.openurl,
                    showLink: res.data.openurl_switch,
                    nocheck: res.data.nocheck,
                    approve_switch: res.data.isCheck,
                    // import_mode: res.data.import_style, ???? 为什么系统管理员默认是替换
                    emailCodeLogin: res.data.emailCodeLogin,
                    mobileCodeLogin: res.data.mobileCodeLogin,
                    mergeDept: res.data.mergeDept,
                    urlDepartmentId: deparst,
                })
            }).catch(res => {
    
            })
        }
        
    }

    switchBody = (event) => {
        if (event.target.classList[0] === "menu-item") {
            for (let i = 0; i < event.target.parentNode.childNodes.length; i++) {
                event.target.parentNode.childNodes[i].classList.remove("active")
            }
            event.target.classList.add("active")
            if (event.target.classList[1] === "singleInvite") {
                this.setState({
                    singleInvite: true,
                    batchInvite: false,
                    formRef: false
                })
            } else if (event.target.classList[1] === "batchInvite") {
                this.setState({
                    singleInvite: false,
                    batchInvite: true,
                    formRef: false
                })
            } else if (event.target.classList[1] === "formRef") {
                this.setState({
                    singleInvite: false,
                    batchInvite: false,
                    formRef: true
                })
            }
        }
    }

    handleCopy = () => {
        const spanText = this.copyCont.current.innerText;
        BsyUtils.copyToClipboard(spanText)
        tipAlert({
            type: "success",
            msg: React.language('app.edit.copy.success')
        });
    };

    changeNickname = (event) => {
        const { value } = event.target
        this.setState({
            nickname: value,
            nicknameError: false,
        })
    }

    changeUserUniqueId = (event) => {
        const { value } = event.target
        this.setState({
            userUniqueId: value,
            userUniqueIdError: false
        })
    }

    changeRemark = (event) => {
        const { value } = event.target
        this.setState({
            remark: value,
        })
    }

    changePhone = (event) => {
        const { value } = event.target
        this.setState({
            phone: value,
            phoneError: false
        })
    }


    changeEmail = (event) => {
        const { value } = event.target
        this.setState({
            email: value,
            emailError: false
        })
    }

    manualClear = () => {
        this.setState({
            nickname: "",
            phone: "",
            userUniqueId: "",
            remark: "",
            departmentId: [],
            role: [],
            otherLabelId: []
        })
    }

    inviteClick = (q) => {
        const { nickname, userUniqueId, departmentId, emailCodeLogin, mobileCodeLogin, role, remark, dock_corpid } = this.state
        let countryCode = this.getPhone ? this.getPhone.state.countryCode : "+86";
        let phone = this.getPhone ? this.getPhone.state.value : null;
        let email = this.getEmail ? this.getEmail.state.value : null;
        let requiredTip = "";
        let flag = true;
        if (nickname === "") {
            this.setState({ nicknameError: true })
            flag = false;
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
            requiredTip = React.language('invite.phone.or.email.required')
        } else if (!emailCodeLogin && mobileCodeLogin) {
            requiredTip = React.language('invite.phone.required')
        } else if (emailCodeLogin && !mobileCodeLogin) {
            requiredTip = React.language('invite.email.required')
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
            if(!phone && !email){
                if (!email) {
                    this.setState({ emailError: true}, () => {
                        tipAlert({
                            type: 'warning',
                            msg: requiredTip
                        })
                    })
                }
                if(!phone){
                    this.setState({ phoneError: true }, () => {
                        tipAlert({
                            type: 'warning',
                            msg: requiredTip
                        })
                    })
                }
                flag = false;
            }
        }else{
            if (!phone && mobileCodeLogin) {
                this.setState({ phoneError: true }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                flag = false;
            }
            if (!email && emailCodeLogin) {
                this.setState({ emailError: true }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                flag = false;
            }
        }

        if (!(departmentId && departmentId.length > 0)) {
            this.setState({ deparsError: true }, () => {
                tipAlert({
                    type: 'warning',
                    msg: React.language('dept.entry.tip')
                })
            })
            flag = false;
        }

        if (!flag) {
            return
        }


        let depars = departmentId.map((item, index) => {
            return item._id
        })
        const c = window.FX.Utils.createLoadLayer(this.dialogEl.current, {
            isLight: !0,
            hasLoader: !0
        });
        React.axios('/corp/invite_check', {}).then(res => {
            if (!res.data.check) {

                React.axios('/corp/member/invite', {
                    corpId: window.FX.STATIC.corpId,
                    nickname: nickname,
                    phone: {
                        phone: phone,
                        code: countryCode
                    },
                    remark: remark,
                    role: role,
                    email: email,
                    departmentId: depars,
                    userUniqueId: window.hasJarvisbim ? email : userUniqueId,//贾维斯本地版 userUniqueId 的值与 email保持一致
                }).then(res => {
                    // const { target } = this.props;
                    // target.parentNode.remove();
                    if (res.data.code == '-1') {
                        c && c.remove();
                        BsyAlert({
                            title: React.language("consolidate.departments.groups.title"),
                            text4Ok: React.language("yes"),
                            text4Cancel: React.language("no"),
                            ok: () => {
                                React.axios('/corp/member/invite', {
                                    corpId: window.FX.STATIC.corpId,
                                    nickname: nickname,
                                    phone: {
                                        phone: phone,
                                        code: countryCode
                                    },
                                    role: role,
                                    remark: remark,
                                    merge_dept: true,
                                    email: email,
                                    departmentId: depars,
                                    userUniqueId: window.hasJarvisbim ? email : userUniqueId,//贾维斯本地版 userUniqueId 的值与 email保持一致
                                }).then(res => {
                                    // const { target } = this.props;
                                    // target.parentNode.remove();
                                    
                                    const { target, onRefresh } = this.props;
                                    if (onRefresh) {
                                        onRefresh();
                                    }

                                    target.parentNode.remove();
                                })
                                return true;
                            }
                        })
                    } else {
                        const { target, onRefresh } = this.props;
                        c && c.remove();
                        if (onRefresh) {
                            onRefresh();
                        }

                        target.parentNode.remove();
                    }

                }).catch(res => {
                    c && c.remove();
                })
            } else {
                c && c.remove();
                imgCodeAlert({
                    type: "success",
                    title: React.language('verification.img.code'),
                    onOk: (args) => {
                        const c1 = window.FX.Utils.createLoadLayer(this.dialogEl.current, {
                            isLight: !0,
                            hasLoader: !0
                        });
                        if (!args.value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('code.not.empty')
                            });
                            return;
                        }
                        if (args.onClose) {
                            args.onClose()
                        }
                        React.axios('/corp/member/invite', {
                            corpId: window.FX.STATIC.corpId,
                            nickname: nickname,
                            phone: {
                                phone: phone,
                                code: countryCode
                            },
                            role: role,
                            email: email,
                            departmentId: depars,
                            remark: remark,
                            "ver_code": args.value, //验证码
                            userUniqueId: window.hasJarvisbim ? email : userUniqueId,//贾维斯本地版 userUniqueId 的值与 email保持一致
                        }).then(res => {
                            if (res.data.code == '-1') {
                                c1 && c1.remove();
                                BsyAlert({
                                    title: React.language("consolidate.departments.groups.title"),
                                    text4Ok: React.language("yes"),
                                    text4Cancel: React.language("no"),
                                    ok: () => {
                                        React.axios('/corp/member/invite', {
                                            corpId: window.FX.STATIC.corpId,
                                            nickname: nickname,
                                            phone: {
                                                phone: phone,
                                                code: countryCode
                                            },
                                            role: role,
                                            merge_dept: true,
                                            email: email,
                                            departmentId: depars,
                                            remark: remark,
                                            userUniqueId: window.hasJarvisbim ? email : userUniqueId,//贾维斯本地版 userUniqueId 的值与 email保持一致
                                        }).then(res => {
                                            // const { target } = this.props;
                                            // target.parentNode.remove();

                                            BsyUtils.showAjaxTip(res.data, () => {
                                                const { target, onRefresh } = this.props;
                                                if (onRefresh) {
                                                    onRefresh();
                                                }

                                                target.parentNode.remove();
                                                // tipAlert({
                                                //     type: "success",
                                                //     msg: res.data.msg
                                                // });
                                            })
                                        })
                                        return true;
                                    }
                                })
                            } else {
                                BsyUtils.showAjaxTip(res.data, () => {
                                    const { target, onRefresh } = this.props;
                                    c1 && c1.remove();
                                    if (onRefresh) {
                                        onRefresh();
                                    }

                                    target.parentNode.remove();
                                    // tipAlert({
                                    //     type: "success",
                                    //     msg: res.data.msg
                                    // });
                                })
                            }

                        })

                    }
                })
            }
        }).catch(res => {
            c && c.remove();
        })
    }

    inviteOtherClick = () =>{
        const { nickname, userUniqueId, otherLabelId, emailCodeLogin, mobileCodeLogin, role, remark, dock_corpid } = this.state
        let countryCode = this.getPhone ? this.getPhone.state.countryCode : "+86";
        let phone = this.getPhone ? this.getPhone.state.value : null;
        let email = this.getEmail ? this.getEmail.state.value : null;
        let requiredTip = "";
        let flag = true;
        if (nickname === "") {
            this.setState({ nicknameError: true })
            flag = false;
        }

        if (dock_corpid === "") {
            this.setState({ dockCorpIdError: true })
            flag = false;
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
            requiredTip = React.language('invite.phone.or.email.required')
        } else if (!emailCodeLogin && mobileCodeLogin) {
            requiredTip = React.language('invite.phone.required')
        } else if (emailCodeLogin && !mobileCodeLogin) {
            requiredTip = React.language('invite.email.required')
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin)) {
            if(!phone && !email){
                if (!email) {
                    this.setState({ emailError: true}, () => {
                        tipAlert({
                            type: 'warning',
                            msg: requiredTip
                        })
                    })
                }
                if(!phone){
                    this.setState({ phoneError: true }, () => {
                        tipAlert({
                            type: 'warning',
                            msg: requiredTip
                        })
                    })
                }
                flag = false;
            }
        }else{
            if (!phone && mobileCodeLogin) {
                this.setState({ phoneError: true }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                flag = false;
            }
            if (!email && emailCodeLogin) {
                this.setState({ emailError: true }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                flag = false;
            }
        }


        if (!flag) {
            return
        }


        let depars = otherLabelId.map((item, index) => {
            return item.role_id
        })
        let mask = window.FX.Utils.createLoadLayer(window.$(this.dialogEl.current), {
            hasLoader: !0,
            isLight: !0
        })
        React.axios("/corp/dock/member/create",{
            dock_corpid: dock_corpid,
            corpId: window.FX.STATIC.corpId,
            nickname: nickname,
            phone: {
                phone: phone,
                code: countryCode
            },
            email: email,
            role: depars,
        }).then(res=>{
            const { onRefresh } = this.props;
            if(res.data.errcode == 1){
                tipAlert({
                    type: 'warning',
                    msg: res.data.errmessage
                })
            }
            mask.remove();
            if (onRefresh) {
                onRefresh(res);
            }
            this.closeAlter();
        }).catch(err => {
            mask.remove();
        })
    }

    _column_2_number = (s) => {
        let result = 0;
        let len = s.length;
        let ch;
        let A = 'A'.charCodeAt();
        for (let i = len - 1; i >= 0; i--) {
            ch = s[i];
            ch = s.charCodeAt(i);
            result = (result + ((ch - A) + 1) * Math.pow(26, len - 1 - i));
        }
        return result;
    }

    _parse_sample_ex2 = (a) => {
        let y_s = 0;
        let x_e = 0;
        let y_e = 0;
        let ref = a['!ref']
        let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/ig;
        let res1 = reg1.exec(ref)
        y_s = Number(res1[2]) - 1;
        x_e = this._column_2_number(res1[3]);
        y_e = Number(res1[4]);
        let result = new Array(y_e > 500 ? 500 : y_e);
        let array_value = new Array(y_e);
        for (let i = y_s; i < y_e; i++) {
            array_value[i] = [];
            if (i < 500)
                result[i] = [];
            for (let j = 0; j < x_e; j++) {
                array_value[i][j] = "";
                if (i < 500)
                    result[i][j] = {};
            }
        }
        for (let k in a) {
            let reg = /([a-zA-Z]+)([0-9]+)/ig;
            let res = reg.exec(k)
            if (!res)
                continue;
            let x = this._column_2_number(res[1]) - 1;
            let y = Number(res[2]) - 1;
            let val = { value: a[k].v, type: a[k].t };
            if (y < 500)
                result[y][x] = val;
            array_value[y][x] = a[k].v;
        }
        this.setState({
            array_value: array_value,
            excelTotal: array_value.length - 1
        })
        return result;
    }

    _previewExcelData = (a1, event) => {
        const txt = React.language('role.import.tip');
        // eslint-disable-next-line no-unused-vars
        let { cacheKey, sheetName, formName, excel_data, cuurmobiletype } = this.state
        let wb;
        let f = a1[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            wb = XLSX.read(data, { type: 'binary' });
            cacheKey = a1.cacheKey;
            sheetName = wb.SheetNames[0];
            var b = a1;
            a1 = [];
            a1.sheetList = wb.SheetNames;
            formName = React.language("import.form");
            if (b && b.length > 0) {
                (formName = b[0].name.replace(".xlsx", "").replace(".xls", ""));
                if (wb.Sheets[sheetName].hasOwnProperty("!merges")) {
                    tipAlert({
                        type: "warning",
                        msg: txt
                    });
                    event.target.value = '';
                }
                else {
                    //必填手机号码，手机号码为空直接过滤当前数据
                    excel_data = wb.Sheets;
                    let items = this._parse_sample_ex2(wb.Sheets[sheetName]), g = true;
                    let array_value = [];
                    cuurmobiletype = false;
                    if (items.length > 0) {
                        //unique
                        if (g) {
                            if ((array_value.length - 1) <= 200) {
                                this.setState({ excelName: f.name.replace(".xlsx", "").replace(".xls", ""), excelTable: items })
                                event.target.value = '';
                            } else {
                                tipAlert({
                                    type: "warning",
                                    msg: '数据条数超过限制，最大值为200条'
                                });
                                event.target.value = '';
                            }
                        } else {
                            tipAlert({
                                type: "warning",
                                msg: txt
                            });
                            event.target.value = '';
                        }
                    } else {
                        tipAlert({
                            type: "warning",
                            msg: txt
                        });
                        event.target.value = '';
                    }
                }
            }
        }

        reader.readAsBinaryString(f);
    }

    uploadFile = (event) => {
        const img = event.target.files;
        this._previewExcelData(img, event);
    }

    downFile = () => {
        window.location.href = window.rootDirectroy + '/wps/' + React.language('wps.xlsx.file.name')
    }

    importClick = () => {
        const { excelTable, departmentId, import_mode } = this.state
        const c = window.FX.Utils.createLoadLayer(window.$('.invite-body'), {
            isLight: !0,
            hasLoader: !0
        });
        React.axios("/manager/team/" + (window.FX.STATIC.currentCorpId || window.FX.STATIC.corpId) + "/importvalue", {
            excel: excelTable,
            // import_mode: import_mode,
            departmentId: BsyUtils.isObjectEmpty(departmentId) ? null : departmentId[0]._id,
        }).then(res => {
            c.remove()
            const data = res.data
            if (data.hasOwnProperty("msg") && data.hasOwnProperty("code") && data.code > 0) {
                tipAlert({
                    type: "warning",
                    msg: data.msg
                })
                return;
            }

            var t = data.data;
            if (t.success > 0) {
                this.setState({
                    errInfo: t.errinfo,
                    excelTable: t.info,
                    errCount: t.errcount,
                    existCount: t.existcount,
                    newCount: t.newcount,
                    errTipShow: true
                })
                if (t.newcount > 0) {
                    const { onRefresh } = this.props;
                    if (onRefresh) {
                        onRefresh();
                    }
                }
            } else {
                // tipAlert({
                //     type: "warning",
                //     msg: '系统错误，导入失败'
                // })
            }
        }).catch(res => {
            c.remove()
        })
    }

    downErrorInfo = () => {
        const { errInfo } = this.state
        React.axios("/manager/team/" + (window.FX.STATIC.currentCorpId || window.FX.STATIC.corpId) + "/downloaderr", {
            excel: errInfo
        }).then(res => {
            var h = res.data.data;
            if (h.success > 0) {
                window.location.href = h.info;
            }
        }).catch(res => {

        })
    }

    doneClick = () => {
        this.setState({
            singleInvite: false,
            batchInvite: true,
            formRef: false,
            nicknameError: false,
            dockCorpIdError: false,
            userUniqueIdError: false,
            phoneError: false,
            emailError: false,
            deparsError: false,
            showLink: false,
            nocheck: false,
            linkAddress: "",
            nickname: "",
            phone: "",
            userUniqueId: "",
            remark: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: [],
            errInfo: [],
            cacheKey: ""
        })
    }

    switchChange = (val) => {
        let depars
        if (BsyUtils.isSubAdmin()) {
            depars = this.state.urlDepartmentId.map((item, index) => {
                return item._id
            })
            depars = depars[0]
        } else {
            depars = this.props.deptId;
        }
        if(this.state.isOther){
            React.axios('/corp/dock/member/update_join_link', {
                dock_corpid: this.state.dock_corpid,
                openurl_switch: val,
                _id: depars,
                corpId: window.FX.STATIC.corpId
            }).then(res => {
                this.setState({ showLink: res.data.openurl_switch, linkAddress: res.data.openurl, approve_switch: res.data.isCheck })
            }).catch(res => {
    
            })
        }else{
            React.axios('/corp/member/invite_openurl_set', {
                dock_corpid: this.state.dock_corpid,
                hasLink: val,
                _id: depars,
                corpId: window.FX.STATIC.corpId
            }).then(res => {
                this.setState({ showLink: res.data.openurl_switch, linkAddress: res.data.openurl, approve_switch: res.data.isCheck })
            }).catch(res => {
    
            })
        }
        
    }

    qrcodeAlert = (event) => {
        event.stopPropagation()
        const pot = event.currentTarget.getBoundingClientRect()
        const css = 160 > (document.documentElement.clientHeight - pot.top + event.currentTarget.offsetHeight + 2) ? {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
        } : {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            top: pot.top + event.currentTarget.offsetHeight + 2 + 'px'
        }
        const { linkAddress } = this.state
        BsyAlertQrcode({
            value: linkAddress,  //value参数为生成二维码的链接
            size: 160, //二维码的宽高尺寸
            css: css,
            text: React.language('msg.qrCode'),
            fgColor: "#000000"
        })
    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }

    emailValue = (rel) => {
        this.getEmail = rel
    }

    closeAlter = () => {
        const { target } = this.props;
        target.parentNode.remove();
    }

    urlDepartmentAlert = () => {
        let that = this;
        const { urlDepartmentId } = this.state;
        const depars = urlDepartmentId.map((item, index) => {
            return item._id
        })
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    checkType: 'radio',
                    value: depars,
                    hasDock: false,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.departs.length === 0) {
                    tipAlert({
                        type: 'warning',
                        msg: React.language('dept.entry.tip1')
                    })
                    return
                }

                const members = d1.departs.map((item, index) => {
                    //selectMap

                    return {
                        nickname: dept.selectMap[item].name,
                        _id: item,
                    }
                })

                that.setState({
                    urlDepartmentId: members
                }, () => {
                    that.switchChange(true);
                })

                return !1;
            }
        });
        d.show()
    }

    memberAlert = (event) => {
        let that = this;
        const { departmentId } = this.state;
        const depars = departmentId.map((item, index) => {
            return item._id
        })
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    value: depars,
                    hasDock: false,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.departs.length === 0) {
                    tipAlert({
                        type: 'warning',
                        msg: React.language('dept.entry.tip1')
                    })
                    return
                }

                const members = d1.departs.map((item, index) => {
                    //selectMap

                    return {
                        nickname: dept.selectMap[item].name,
                        _id: item,
                    }
                })

                that.setState({
                    departmentId: members,
                    deparsError: false
                })

                return !1;
            }
        });
        d.show()
    }


    approve_list = (val) => {

        BsyDialog({
            title: React.language('member') + React.language('member.invite.link.Audit.list'),
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyApprovePane
                    _id={this.props.deptId}
                    mode={'member'} status={3} />
            }
        })

    }


    approve_switch_Change = (val) => {
        let depars
        if (BsyUtils.isSubAdmin()) {
            depars = this.state.urlDepartmentId.map((item, index) => {
                return item._id
            })
            depars = depars[0]
        } else {
            depars = this.props.deptId;
        }
        React.axios('/corp/member/invite_openurl_set', {
            dock_corpid: this.state.dock_corpid,
            isCheck: val,
            _id: depars,
            corpId: window.FX.STATIC.corpId
        }).then(res => {
            this.setState({ approve_switch: res.data.isCheck })
        }).catch(res => {

        })
    }

    mergeDeptChange = (val) => {
        this.setState(val);
    }

    _createChangeRoleBubble = (b) => {
        let that = this;
        const { role } = this.state;
        const roles = role.map((item, index) => {
            return item._id
        })
        b.target.classList.add("select")
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 586,
            width: 956,
            contentWidget: {
                rowSize: [450],
                colSize: [926],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    editable: !0,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    outsiderGroupEnable: !1,
                    roleEnable: !0,
                    roleChildEnable: !0,
                    dynamicEnable: !1,
                    dynamicType: "set",
                    hasDock: false,
                    value: roles,
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect");
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.roles.length === 0) {
                    that.setState({
                        role: []
                    })
                    return !1;
                }
                const role = d1.roles.map((item, index) => {
                    return {
                        id: dept.selectMap[item].role_id,
                        name: dept.selectMap[item].name,
                        _id: item,
                    }
                })
                that.setState({
                    role: role
                })
                b.target.classList.remove("select")
                return !1;
            },
            onClose: function () {
                b.target.classList.remove("select")
            }
        });
        d.show()
    }

    blurEmail = (event) => {
        const { value } = event.target;
        const { userUniqueId } = this.state;
        if (userUniqueId === "") {
            this.setState({
                userUniqueId: value,
                userUniqueIdError: false
            })
        }
    }

    roleAlert = () =>{
        const {otherLabelId} = this.state;
        const _this = this;
        let otherValueList = otherLabelId.map(res=>{
            return res.role_id
        })
        React.axios("/corp/dock/role/list").then(res=>{
            const d = new window.FX.ConfirmDialog({
                title: React.language("contact.external.role.list"),
                height: 576,
                width: 710,
                contentWidget: {
                    rowSize: [440],
                    colSize: [680],
                    padding: 15,
                    items: [[{
                        widgetName: "memberSelect",
                        type: "memberselectpane",

                        editable: !0,
                        memberEnable: !1,
                        departmentEnable: !1,
                        outsiderMemberEnable: !1,
                        outsiderGroupEnable: !1,
                        roleEnable: !1,
                        corpEnable: !0,
                        dynamicEnable: !1,
                        dynamicType: "set",
                        iconType: "corpRole",
                        itemTitle: React.language("role"),
                        items: res.data.role_list,
                        hasDock: false,
                        value: otherValueList,
                    }]]
                },
                onOk: function () {
                    let dept = d.getWidgetByName("memberSelect");
                    let d1 = dept.getAllJsonValue();
                    let role_id_list = [];
                    res.data.role_list.map(res=>{
                        if(d1.corpRoleValue.indexOf(res.role_id) > -1){
                            role_id_list.push(res)
                        }
                    });
                    
                    _this.setState({otherLabelId: role_id_list});
                    return !1;
                }
            });
            d.show()
        })
    }

    filterPane = (event, type) => {
        const {dock_corp} = this.state;
        this.setState({dockCorpIdError: false})
        let bts = []

        dock_corp.map(res=>{
            bts.push({ 
                icon: '', 
                text: res.dock_corpname, 
                click: () =>{
                    this.setState({filterText: res.dock_corpname, dock_corpid: res.dock_corpid},()=>{
                        // this.RefreshList()
                    })
                }
            })
        })
        const t = event.currentTarget;
        t.classList.add('open');
        BsyAlertMenu({
            item: bts,
            width: 566,
            target: event.target,
            customCls: ' data-manage-batch-menu ',
            onClose: ()=>{
                t.classList.remove('open');
                return !0
            }
        })
    }


    render() {
        const { batchInvite, singleInvite, formRef, nickname, phone,
            userUniqueId, nicknameError, dockCorpIdError, userUniqueIdError, phoneError, excelName, excelTotal, remark, filterText,
            excelTable, errTipShow, errCount, existCount, newCount, showLink, linkAddress, nocheck, approve_switch, departmentId, email, emailError, deparsError, emailCodeLogin, mobileCodeLogin, role, import_mode, urlDepartmentId, isAllDept, isOther, isAddRoleLabel, otherLabelId } = this.state
        const { title, styleCss } = this.props;
        let urlDepartmentIdName = '';
        let departmentIdName = '';
        urlDepartmentIdName += urlDepartmentId.map((val, index) => {
            return val.nickname
        })
        departmentIdName += departmentId.map((val) => {
            return val.nickname
        })
        return (
            <div className={"content " + window.mode} style={styleCss} ref={this.dialogEl}>
                <div className="dialog-header">
                    <span className="title">{title}</span>
                    <i onClick={this.closeAlter} className="icon-close-large" />
                </div>
                <div className="dialog-body">
                    {!isAddRoleLabel && <div className="invite-menu" onClick={this.switchBody}>
                        <div className="menu-item singleInvite active">{React.language('member.invite.manual')}</div>
                        {!isOther && <div className="menu-item batchInvite">{React.language('member.invite.import')}</div>}
                        <div className="menu-item formRef">{React.language('member.invite.public.link')}</div>
                    </div>}
                    <div className="invite-body" style={{height: isAddRoleLabel ? "100%" : ""}}>
                        {singleInvite && <div className="singleInvite">
                            <div className="manualCont">
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('name')}</div>
                                        <div className="label-tip">
                                            *
                                        </div>
                                    </div>
                                    <input className={nicknameError ? "error" : ""} value={nickname} maxLength="64" onChange={this.changeNickname} type="text" placeholder={React.language('max.length.64')} />
                                </div>
                                {
                                    isAddRoleLabel && <div className="input-item">
                                        <div className="input-label">
                                            <div className="label-title">{React.language('enterprise')}</div>
                                            <div className="label-tip">*</div>
                                        </div>
                                        <div className={"filter-btn" + (dockCorpIdError ? " error" : "")} onClick={this.filterPane}>
                                            {
                                                !!filterText ? <span>{filterText}</span> : <span style={{color: '#ccc'}}>{React.language('contact.handover.corp.empty')}</span>
                                            }
                                            <i className="icon-bsy-xia"></i>
                                        </div>
                                    </div>
                                }
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('phone')}</div>
                                        {
                                            (mobileCodeLogin || (!emailCodeLogin && !mobileCodeLogin)) ? <div className="label-tip">*</div> : ''
                                        }

                                    </div>
                                    <LoginAccountInput getValue={this.phoneValue} change={this.changePhone} error={phoneError} maxLength="12" value={phone} mode="mobile" placeholder={React.language('phone.entry.tip')} />
                                </div>
                                <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('email')}</div>
                                        {
                                            (emailCodeLogin || (!emailCodeLogin && !mobileCodeLogin)) ? <div className="label-tip">*</div> : ''
                                        }
                                    </div>
                                    <LoginAccountInput getValue={this.emailValue} change={this.changeEmail} error={emailError} maxLength="128" value={email} mode="email" placeholder={React.language('email.entry.tip')} />
                                </div>

                                {(!window.hasJarvisbim && !isOther) && <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('enterprise.userID')}</div>
                                        {
                                            //贾维斯本地版 去除企业ID 和邮箱值保持一致
                                        }
                                    </div>
                                    <input className={userUniqueIdError ? "error" : ""} value={userUniqueId} onChange={this.changeUserUniqueId} type="text" placeholder={React.language('enterprise.tip2')} />
                                </div>}
                                {
                                    !isOther && <div className="input-item">
                                        <div className="input-label">
                                            <div className="label-title">{React.language('contact.note.title')}</div>
                                        </div>
                                        <input value={remark} onChange={this.changeRemark} maxLength="64" type="text" placeholder={React.language('max.length.64')} />
                                    </div>
                                }
                                {
                                    !isOther && <div className="input-item">
                                        <div className="input-label">
                                            <div className="label-title">{React.language('department')}</div>
                                            <div className="label-tip">
                                                *
                                            </div>
                                        </div>
                                        <div className={"departmentCont " + (deparsError ? "error" : "")} onClick={this.memberAlert} >
                                            {
                                                departmentId.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                                    departmentId.map((item, index) => {
                                                        return <div className="item-content"><i className="icon-department"></i><span>{item.nickname}</span></div>
                                                    })
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    isOther && <div className="input-item">
                                    <div className="input-label">
                                        <div className="label-title">{React.language('role')}</div>
                                    </div>
                                    <div className={"departmentCont " + (deparsError ? "error" : "")} onClick={this.roleAlert} >
                                        {
                                            otherLabelId.length === 0 ? <div className="select-empty"><span>{React.language('role.select.tip')}</span></div> :
                                                otherLabelId.map((item, index) => {
                                                    return <div className="item-content"><i className="icon-role"></i><span>{item.name}</span></div>
                                                })
                                        }
                                    </div>
                                </div>
                                }
                                {
                                    // 贾维斯去掉角色选择
                                    // <div className="input-item">
                                    //     <div className="input-label">
                                    //         <div className="label-title">{React.language('role')}</div>
                                    //     </div>
                                    //     <div className='departmentCont' onClick={this._createChangeRoleBubble}>
                                    //         {
                                    //             role.length === 0 ? <div class="select-empty"><span>{React.language('role.select.tip')}</span></div> :
                                    //                 role.map(item => {
                                    //                     return <div className="item-content role"><i className="icon-role" /><span>{item.name}</span></div>
                                    //                 })
                                    //         }
                                    //     </div>
                                    // </div>
                                }
                            </div>
                            <div className="manualBtn">
                                <BsyIconBtn
                                    text={React.language('clear')}
                                    type="white"
                                    click={this.manualClear}
                                    mode={window.mode}
                                />
                                <BsyIconBtn
                                    text={isOther ? React.language('add') : React.language('invite')}
                                    type="blue"
                                    click={isOther ? this.inviteOtherClick : this.inviteClick}
                                    mode={window.mode}
                                />
                            </div>
                        </div>}
                        {(batchInvite && !isOther) && <div className="batchInvite">
                            {errTipShow ? <div className="batchErrTip">
                                <div className="errorTip">
                                    {React.language('batch.error.tip', { success: newCount, exist: existCount, error: errCount })}
                                </div>
                                <div className="errorBtn">
                                    <BsyIconBtn
                                        text={React.language('batch.error.btn')}
                                        type="white"
                                        click={this.downErrorInfo}
                                        mode={window.mode}
                                    />
                                </div>
                            </div> : <div className="batchBtn">
                                <div className={"r-btn " + window.mode}>
                                    <i className="icon-bsy-file" />
                                    <span>{React.language('widget.file.select')}</span>
                                    <form className="upload-form " action="" encType="multipart/form-data"
                                        method="post">
                                        <input onChange={this.uploadFile} type="file" name="file" id="file"
                                            className="upload-btn-input" accept=".xlsx,.xls" />
                                    </form>
                                </div>
                                <BsyIconBtn
                                    text={React.language('Download.btn1')}
                                    iconName="icon-bsy-reportmenu-8"
                                    type="r-btn white "
                                    click={this.downFile}
                                    mode={window.mode}
                                />
                            </div>}
                           
                            {excelTable.length <= 0 && <div className="batchTip">
                                <p>{React.language("widget.file.select")}</p>
                                <ul>
                                    <li>{nocheck ? React.language("invite.Download1") : React.language("invite.Download8")}</li>
                                </ul>
                                <p>{React.language("invite.Download.title")}</p>
                                <ul>
                                    <li>{React.language("invite.Download2")}</li>
                                    <li>{React.language("invite.Download3")}</li>
                                    <li>{React.language("invite.Download4")}</li>
                                    <li>{React.language("invite.Download5")}</li>
                                    <li>{React.language("invite.Download6")}</li>
                                    {
                                        // 贾维斯本地版 不需要显示
                                        window.hasJarvisbim ? '' : <>
                                            <li>{React.language("invite.Download7")}</li>
                                            {nocheck && <li>{React.language("invite.Download9")}</li>}</>

                                    }

                                </ul>
                            </div>}
                            {excelTable.length > 0 && <div className="batchTable">
                                <div className="invite-content">
                                    <div className="excel-import-tool">
                                        <span>{React.language('excel')}-{excelName}</span>
                                        <span style={{ float: 'right' }}>{React.language("Total.data")}{excelTotal}{React.language('tiao')}</span>
                                    </div>
                                    <div className="excel-import-table">
                                        <div className={"excel-import-grid react_excel_grid " + (errTipShow ? "import" : "")}
                                            style={{ width: 'auto', maxHeight: '160px' }}>
                                            <div className="excel-border">

                                            </div>
                                            <table cellPadding="0" cellSpacing="0">
                                                <tbody>
                                                    <tr className="row-head">
                                                        <td className="row-idx" rowSpan="1"><span
                                                            className="row-num">1</span><span
                                                                className="row-label">{React.language('')}</span>
                                                        </td>
                                                        {
                                                            excelTable[0].map((val, key) => {
                                                                return <td key={key}><span>{val.value}</span></td>
                                                            })
                                                        }
                                                    </tr>
                                                    {
                                                        excelTable.map((val, key) => {
                                                            return key !== 0 && <tr key={key}>
                                                                <td className="row-idx" rowSpan="1"><span
                                                                    className="row-num">{key + 1}</span><span
                                                                        className="row-label">{React.language('import.rowHead')}</span>
                                                                </td>
                                                                {
                                                                    val.map((val1, key1) => {
                                                                        return <td key={key1}><span>{val1.value}</span></td>
                                                                    })
                                                                }
                                                            </tr>
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                {errTipShow ? <div className="invite-btn" key={'done'} >
                                    <BsyIconBtn
                                        text={React.language('done')}
                                        type="blue"
                                        click={this.doneClick}
                                        mode={window.mode}
                                    />
                                </div> : <div className="invite-btn" key={'import'}>
                                    <BsyIconBtn
                                        text={React.language('import')}
                                        type="blue"
                                        click={this.importClick}
                                        mode={window.mode}
                                    />
                                    <BsyIconBtn
                                        text={React.language('cancel')}
                                        type="white"
                                        click={this.doneClick}
                                        mode={window.mode}
                                    />
                                </div>}
                            </div>}
                        </div>}
                        {formRef && <div className="form-ref">
                            {BsyUtils.isSubAdmin() && isAllDept && <div className="ref-list">
                                <div className="list-label link">
                                    <span className="list-title">{React.language('department')}</span>
                                </div>
                                <div className="departmentCont" onClick={this.urlDepartmentAlert} >
                                    {
                                        urlDepartmentId.length === 0 ? <div className="select-empty"><span>{React.language('widget.dept.clickToSelect')}</span></div> :
                                            urlDepartmentId.map((item, index) => {
                                                return <div className="item-content"><i className="icon-department"></i><span>{item.nickname}</span></div>
                                            })
                                    }
                                </div>
                            </div>}
                            {(BsyUtils.isSubAdmin() && isAllDept) ? showLink && urlDepartmentId.length !== 0 && <div className="ref-list">
                                <div className="list-label">
                                    <span className="list-title">{React.language('member.invite.link')}</span>
                                    <span className="label-info">{isOther ? React.language('external.member.invite.tip1') : React.language('member.invite.link.tip')}</span>
                                    {showLink}
                                    <BsySwitchBtn key={formRef} power={showLink} switchChange={this.switchChange} />
                                </div>
                            </div> : <div className="ref-list">
                                <div className="list-label">
                                    <span className="list-title">{React.language('member.invite.link')}</span>
                                    <span className="label-info">{isOther ? React.language('external.member.invite.tip1') : React.language('member.invite.link.tip')}</span>
                                    {showLink}
                                    <BsySwitchBtn key={formRef} power={showLink} switchChange={this.switchChange} />
                                </div>
                            </div>}
                            {(BsyUtils.isSubAdmin() && isAllDept) ? showLink && urlDepartmentId.length !== 0 && <div className="ref-list">
                                <div className="list-label link">
                                    <span className="list-title">{React.language('link.address')}</span>
                                    {isOther && <span className="label-info">{React.language('external.member.invite.tip2')}</span>}
                                    {
                                        BsyUtils.isObjectEmpty(urlDepartmentId) ? '' : <span className="list-title dept">{" (" + React.language('url.join.dept.tip') + " - " + (isAllDept ? urlDepartmentIdName : departmentIdName) + ")"}</span>
                                    }
                                </div>
                                <div className="list-label link share">
                                    <div className="url item" ref={this.copyCont}>{linkAddress}</div>
                                    <div className="copy item" onClick={this.handleCopy}>{React.language('copy')}</div>
                                    <div className="qr item" onClick={this.qrcodeAlert}>
                                        <i className="icon-qrcode" />
                                    </div>
                                </div>
                            </div> : showLink && <div className="ref-list">
                                <div className="list-label link">
                                    <span className="list-title">{React.language('link.address')}</span>
                                    {isOther && <span className="label-info">{React.language('external.member.invite.tip2')}</span>}
                                    {
                                        BsyUtils.isObjectEmpty(urlDepartmentId) ? '' : <span className="list-title dept">{" (" + React.language('url.join.dept.tip') + " - " + (isAllDept ? urlDepartmentIdName : departmentIdName) + ")"}</span>
                                    }
                                </div>
                                <div className="list-label link share">
                                    <div className="url item" ref={this.copyCont}>{linkAddress}</div>
                                    <div className="copy item" onClick={this.handleCopy}>{React.language('copy')}</div>
                                    <div className="qr item" onClick={this.qrcodeAlert}>
                                        <i className="icon-qrcode" />
                                    </div>
                                </div>
                            </div>}
                            {!isOther && <>
                                {
                                    (BsyUtils.isSubAdmin() && isAllDept) ? showLink && urlDepartmentId.length !== 0 &&
                                        <div className="ref-list">
                                            <div className="list-label">
                                                <span className="list-title">{React.language('member.invite.link.Audit')}</span>
                                                <span className="label-info">{React.language('member.invite.link.Audit.tip')}</span>
                                                <div className="Audit" >
                                                    <BsySwitchBtn power={approve_switch} switchChange={this.approve_switch_Change} />

                                                </div>
                                            </div>
                                        </div> : showLink &&
                                    <div className="ref-list">
                                        <div className="list-label">
                                            <span className="list-title">{React.language('member.invite.link.Audit')}</span>
                                            <span className="label-info">{React.language('member.invite.link.Audit.tip')}</span>
                                            <div className="Audit" >
                                                <BsySwitchBtn power={approve_switch} switchChange={this.approve_switch_Change} />

                                            </div>
                                        </div>
                                    </div>
                                }
                                <BsyIconBtn
                                    text={React.language('member.invite.link.Audit.list')}
                                    click={this.approve_list}
                                    type="blue"
                                    mode={window.mode}
                                />
                            </>}
                            
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default AlertList